import { z } from "zod/v4";

import { ExperienceCategoryList } from "./experience-categories";

export const WidgetCategoryList = [
  "quantityButtons",
  "progressBar",
  "messageBox",
] as const;
export type WidgetCategory = (typeof WidgetCategoryList)[number];

export const WidgetTypeList = [
  "messageBoxPopup",
  "messageBoxSlideOut",
  "quantityButtons",
  "discountProgressBar",
  "shippingProgressBar",
] as const;
export type WidgetType = (typeof WidgetTypeList)[number];

export const WidgetConfigSchema = z.object({
  desktop: z.any().optional(),
  mobile: z.any().optional(),
});

export const WidgetExperienceInfoSchema = z.object({
  name: z.string(),
  category: z.enum(ExperienceCategoryList),
});
export type WidgetExperienceInfo = z.infer<typeof WidgetExperienceInfoSchema>;

export const WidgetStatsSchema = z.object({
  experiences: WidgetExperienceInfoSchema.array(),
});
export type WidgetStats = z.infer<typeof WidgetStatsSchema>;

export const WidgetDtoSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  enabledSitewide: z.boolean().optional().default(false),
  parentId: z.uuid().nullish(),
  widgetType: z.enum(WidgetTypeList),
  config: WidgetConfigSchema,
  stats: WidgetStatsSchema.optional(),
});

export type WidgetDto = z.infer<typeof WidgetDtoSchema>;
